import React from 'react';

// Image-generation models the user can pick from.
// `value` is sent to the worker as `model`; the worker routes
// "nano-banana" to Gemini and anything else to OpenAI.
const MODELS = [
  {
    value: 'gpt-image-1',
    label: 'ChatGPT',
    emoji: '🤖',
    hint: 'OpenAI · sharp & detailed',
  },
  {
    value: 'nano-banana',
    label: 'Nano Banana',
    emoji: '🍌',
    hint: 'Gemini Flash · fastest & free',
  },
  {
    value: 'nano-banana-pro',
    label: 'Nano Banana Pro',
    emoji: '🍌',
    hint: 'Gemini Pro · highest detail',
  },
];

function ModelSwitch({ selectedModel, setSelectedModel, disabled = false }) {
  const active = MODELS.find((m) => m.value === selectedModel) || MODELS[0];

  return (
    <div className="model-switch">
      <span className="model-switch-label">AI Model</span>
      <div className="model-switch-track" role="radiogroup" aria-label="AI model">
        {MODELS.map((model) => (
          <button
            key={model.value}
            type="button"
            role="radio"
            aria-checked={selectedModel === model.value}
            className={`model-switch-btn ${selectedModel === model.value ? 'active' : ''}`}
            onClick={() => setSelectedModel(model.value)}
            disabled={disabled}
            title={model.hint}
          >
            <span className="model-switch-emoji">{model.emoji}</span>
            {model.label}
          </button>
        ))}
      </div>
      <span className="model-switch-hint">{active.hint}</span>
    </div>
  );
}

export default ModelSwitch;
